var map = {
	"./flags/en-16": 16,
	"./flags/en-16.png": 16,
	"./flags/en-32": 17,
	"./flags/en-32.png": 17,
	"./flags/fr-16": 18,
	"./flags/fr-16.png": 18,
	"./flags/fr-32": 19,
	"./flags/fr-32.png": 19,
	"./flags/france-flag-square-icon-32": 20,
	"./flags/france-flag-square-icon-32.png": 20,
	"./flags/united-kingdom-flag-square-icon-32": 21,
	"./flags/united-kingdom-flag-square-icon-32.png": 21,
	"./logo_carre": 22,
	"./logo_carre.png": 22,
	"./logo_v1": 23,
	"./logo_v1.png": 23,
	"./logo_v2": 24,
	"./logo_v2.png": 24,
	"./logo_v3": 25,
	"./logo_v3.png": 25,
	"./prowhy-logo-m": 26,
	"./prowhy-logo-m.png": 26
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;